
import Vue from "vue";

export default Vue.extend({
  props: {
    variant: {
      type: String,
      default: "default"
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    summaryClasses(): Record<string, boolean> {
      return {
        "summary-button--warning": this.variant === "warning",
        "summary-button--clickable": this.clickable
      };
    }
  },
  methods: {
    handleClick(event: MouseEvent) {
      if (!this.clickable) {
        return;
      }

      this.$emit("click", event);
    },
    handleKeydown(event: KeyboardEvent) {
      if (!this.clickable) {
        return;
      }

      this.$emit("click", event);
    }
  }
});
